import { render, staticRenderFns } from "./DocumentationView.vue?vue&type=template&id=86c73b3c"
import script from "./DocumentationView.vue?vue&type=script&lang=js"
export * from "./DocumentationView.vue?vue&type=script&lang=js"
import style0 from "./DocumentationView.vue?vue&type=style&index=0&id=86c73b3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports